var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_57",
    "data-name": "Layer 57"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#78b9eb",
    height: 24.79,
    rx: 6.14,
    width: 24.79,
    x: 4,
    y: 3.86
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#78b9eb",
    height: 24.79,
    rx: 6.14,
    width: 24.79,
    x: 35.38,
    y: 35.38
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#006df0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.85 2.5h-15.23a6.12 6.12 0 0 0 -6.12 6.12v15.22a6.12 6.12 0 0 0 6.12 6.16h15.23a6.12 6.12 0 0 0 6.15-6.16v-15.22a6.12 6.12 0 0 0 -6.15-6.12zm3.15 21.34a3.12 3.12 0 0 1 -3.15 3.16h-15.23a3.12 3.12 0 0 1 -3.12-3.16v-15.22a3.12 3.12 0 0 1 3.12-3.12h15.23a3.12 3.12 0 0 1 3.15 3.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.71 2.5h-15.89a5.79 5.79 0 0 0 -5.82 5.79v15.88a5.78 5.78 0 0 0 5.82 5.83h15.89a5.79 5.79 0 0 0 5.79-5.79v-15.92a5.8 5.8 0 0 0 -5.79-5.79zm2.79 21.67a2.79 2.79 0 0 1 -2.79 2.83h-15.89a2.79 2.79 0 0 1 -2.82-2.83v-15.88a2.79 2.79 0 0 1 2.82-2.79h15.89a2.79 2.79 0 0 1 2.79 2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.85 34h-15.23a6.12 6.12 0 0 0 -6.12 6.15v15.23a6.13 6.13 0 0 0 6.12 6.12h15.23a6.12 6.12 0 0 0 6.15-6.12v-15.23a6.12 6.12 0 0 0 -6.15-6.15zm3.15 21.38a3.12 3.12 0 0 1 -3.11 3.12h-15.27a3.12 3.12 0 0 1 -3.12-3.12v-15.23a3.12 3.12 0 0 1 3.12-3.15h15.23a3.12 3.12 0 0 1 3.15 3.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.71 34h-15.89a5.78 5.78 0 0 0 -5.82 5.82v15.89a5.79 5.79 0 0 0 5.78 5.79h15.93a5.8 5.8 0 0 0 5.79-5.79v-15.89a5.79 5.79 0 0 0 -5.79-5.82zm2.79 21.71a2.79 2.79 0 0 1 -2.79 2.79h-15.89a2.79 2.79 0 0 1 -2.82-2.79v-15.89a2.79 2.79 0 0 1 2.82-2.82h15.89a2.79 2.79 0 0 1 2.79 2.78z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.687eb500e7148431e3a8d56cbac7afb1.svg";
export { ForwardRef as ReactComponent };